/**
 * Pulls the human-readable message out of an error thrown by `req`.
 *
 * For 4xx responses `req` throws the parsed JSON body itself (see
 * throwOnHTTPError in common/api/request.js), so an API payload like
 * `{ "message": "The requested resource could not be found." }` arrives with
 * that text already on `.message`. Anything without a usable string — a network
 * failure, a thrown non-Error, a blank message — yields undefined so the caller
 * can fall back to its own copy.
 */
export const getApiErrorMessage = (error: unknown): string | undefined => {
  if (!error || typeof error !== 'object') {
    return undefined
  }

  const { message } = error as { message?: unknown }

  if (typeof message !== 'string') {
    return undefined
  }

  const trimmed = message.trim()

  return trimmed.length > 0 ? trimmed : undefined
}
